import { useGravityDevice } from "src/hooks/useGravityDevice";
import { SelectMenuLayoutProps } from "src/types";

const isMenuListScroll = (event: Event) =>
  event.target instanceof Element &&
  event.target.getAttribute("role") === "listbox";

const closeMenuOnFiltersScroll = (event: Event) => !isMenuListScroll(event);

export const useFilterSelectMenu = (): SelectMenuLayoutProps => {
  const { isMobile } = useGravityDevice();

  if (isMobile) {
    return { menuPlacement: "auto" };
  }

  return {
    menuPlacement: "auto",
    menuPosition: "fixed",
    menuPortalTarget: document.body,
    closeMenuOnScroll: closeMenuOnFiltersScroll,
  };
};
